import type { ProductTileProduct } from '@moonpig/web-shared-products'

export enum MessageSender {
  User = 'user',
  Agent = 'agent',
}

export enum MessageType {
  Text = 'text',
  FollowUpQuestion = 'follow-up-question',
  Suggestions = 'suggestions',
  Products = 'products',
}

export type SuggestionsSource = 'intro' | 'agent'

export type SuggestionsMessageContent = {
  title?: string
  suggestions: string[]
  supportUrl?: string
  source?: SuggestionsSource
}

export type Suggestion = {
  id: number
  text: string
  source?: SuggestionsSource
}

export type TextMessageContent = string

export type ProductItemType = 'gifts' | 'cards'

export type ProductMessageItem = ProductTileProduct & {
  productType: ProductItemType
  price?: string
  reason?: string
  imageUrl?: string
  productUrl?: string
  imageQuery?: string
}

export type ProductsMessageContent = {
  title?: string
  items: ProductMessageItem[]
}

type BaseChatMessage = {
  sender: MessageSender
}

export type TextChatMessage = BaseChatMessage & {
  type: MessageType.Text | MessageType.FollowUpQuestion
  content: string
}

export type SuggestionsChatMessage = BaseChatMessage & {
  type: MessageType.Suggestions
  content: SuggestionsMessageContent
}

export type ProductsChatMessage = BaseChatMessage & {
  type: MessageType.Products
  content: ProductsMessageContent
}

export type ChatMessage =
  | TextChatMessage
  | SuggestionsChatMessage
  | ProductsChatMessage
